module.exports = "/images/login-page-title.png?e655f693145971eca4ce8b26cb8e46df";